import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { IFlightDetails } from '../interfaces';
import { FlightDetailsMapper } from '../mappers';

export type IGetFlightDetailsRepoResponse = IRepoResponse<200, IFlightDetails> | IRepoResponse<400 | 500, string>;

export type IGetFlightDetailsRepo = IRepo<[{ flightId: string | number }], IGetFlightDetailsRepoResponse>;

export const GetFlightDetailsRepoType = Symbol.for('GetFlightDetailsRepo');

@bind(GetFlightDetailsRepoType)
export class GetFlightDetailsRepo implements IGetFlightDetailsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute({ flightId }) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/flights/airwaybillinfo', { flight_id: flightId }) });

      if (result.status === 200) {
        const data: IFlightDetails = FlightDetailsMapper.toDomain(result.data.data);

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      console.error(e);

      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
